// Estado de cada documento dentro de una sesion de firma. Viaja como NUMERO: el backend no tiene
// JsonStringEnumConverter. `uploaded` solo lo produce el camino de staff (firma en papel) y una
// sesion que lo contenga no sirve para comprar desde el area de socio: el backend responde 403.
export enum ContractSignatureItemResolution {
    pending = 1,
    signed = 2,
    uploaded = 3,
    rejected = 4
}
